function wrapScrollableTables(root = document) {
  root.querySelectorAll('.rte table').forEach((table) => {
    if (table.parentElement.closest('table')) return; // nested — never wrap
    if (table.parentElement.classList.contains('table-scroll')) return; // already wrapped
    const wrapper = document.createElement('div');
    wrapper.className = 'table-scroll';
    table.before(wrapper);
    wrapper.append(table);
  });
}

document.addEventListener('DOMContentLoaded', () => wrapScrollableTables());
document.addEventListener('shopify:section:load', (event) => wrapScrollableTables(event.target));
